module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./ArcGauge.js"));
	}, "ArcGauge");
}